export default __webpack_public_path__ + "static/media/BB.f1866cb5.svg";